/**
 * assets/koi-partners.js
 * Gedrag van sections/koi-partners.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * 2026-09-23 (v6): type-filter werkt op meerdere categorieën per partner (data-cats / p.cats, spatie-gescheiden).
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function(){
  var el=document.getElementById('kp-data'); if(!el||typeof L==='undefined') return;
  var data=[]; try{data=JSON.parse(el.textContent)}catch(e){return;}
  var cards=[].slice.call(document.querySelectorAll('.kp-card'));
  var region=document.getElementById('kp-region'), none=document.getElementById('kp-none');
  var map=L.map('kp-map',{scrollWheelZoom:false}).setView([52.1,5.3],7);
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:18,attribution:'&copy; OpenStreetMap'}).addTo(map);
  var markers=[];
  data.forEach(function(p){ if(p.lat&&p.lng){ var m=L.marker([p.lat,p.lng]); m.bindPopup('<strong>'+p.name+'</strong><br>'+(p.city||'')+'<br><a href="'+p.url+'">Bekijk profiel</a>'); m.pp=p; markers.push(m); m.addTo(map); } });
  function fit(){ var vis=markers.filter(function(m){return map.hasLayer(m);}); if(vis.length){ map.fitBounds(L.featureGroup(vis).getBounds().pad(0.3),{maxZoom:11}); } }
  fit();
  var curType='all';
  function apply(){
    var reg=region?region.value:'', shown=0;
    cards.forEach(function(c){ var ok=(!reg||c.getAttribute('data-province')===reg)&&(curType==='all'||(' '+(c.getAttribute('data-cats')||'')+' ').indexOf(' '+curType+' ')>-1); c.style.display=ok?'':'none'; if(ok)shown++; });
    markers.forEach(function(m){ var ok=(!reg||m.pp.prov===reg)&&(curType==='all'||(' '+(m.pp.cats||'')+' ').indexOf(' '+curType+' ')>-1); if(ok){ if(!map.hasLayer(m))m.addTo(map); } else { if(map.hasLayer(m))map.removeLayer(m); } });
    if(none) none.classList.toggle('hidden', shown>0);
    fit();
  }
  if(region) region.addEventListener('change', apply);
  document.querySelectorAll('.kp-type').forEach(function(b){ b.addEventListener('click', function(){
    document.querySelectorAll('.kp-type').forEach(function(x){x.classList.remove('is-active','bg-navy','text-white');x.classList.add('bg-white','text-navy');});
    b.classList.add('is-active','bg-navy','text-white');b.classList.remove('bg-white','text-navy');
    curType=b.getAttribute('data-type'); apply(); }); });
  var reset=document.getElementById('kp-reset'); if(reset) reset.addEventListener('click', function(){ if(region)region.value=''; curType='all'; document.querySelectorAll('.kp-type').forEach(function(x){x.classList.remove('is-active','bg-navy','text-white');x.classList.add('bg-white','text-navy');}); var a=document.querySelector('.kp-type[data-type="all"]'); if(a){a.classList.add('is-active','bg-navy','text-white');a.classList.remove('bg-white','text-navy');} apply(); });
  setTimeout(function(){ map.invalidateSize(); fit(); }, 200);
})();
